import { FC } from 'react';

import { useFormContext } from 'react-hook-form';
import { Col, FormGroup, Input, Label } from 'reactstrap';

import { SaveForm } from 'types/pages';
import { s } from 'utilities';

const Secondary: FC = () => {
  const { register } = useFormContext<SaveForm>();

  const { ref, ...props } = register('secondarySelect');

  return (
    <FormGroup row>
      <Label sm={4}>{s(['Site.Secondary', 'Site.Select'])}</Label>
      <Col sm={8}>
        <Input
          {...props}
          innerRef={ref}
          readOnly
          rows={3}
          type="textarea"
        />
      </Col>
    </FormGroup>
  );
};

export default Secondary;
